import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { WidgetsComponent } from 'src/app/components/widgets/widgets.component';
import { Title } from '@angular/platform-browser';
import { SeoService } from 'src/app/services/seo.service';
@Component({
  selector: 'app-bosni-articulo',
  templateUrl: './bosni-articulo.component.html',
  styleUrls: ['./bosni-articulo.component.scss']
})
export class BosniArticuloComponent implements OnInit, OnDestroy {
  @ViewChild(WidgetsComponent) child: WidgetsComponent;
  url: string;
  cont: any;
  private routeObs: Subscription;
  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    public route: RoutingService,
    public seo: SeoService,
    public api: RestapiService
  ) {
    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        this.loadContent();
      }, 10);
    });
  }

  ngOnInit(): void {
    this.loadContent();
  }
  ngOnDestroy(): void {
    this.routeObs.unsubscribe();
  }

  loadContent() {
   // this.titleService.setTitle('Fichas digitales');
    this.url = this.activatedRoute.snapshot.paramMap.get('url');
    this.api.getdata('websection', {
      filters: { name: { value: this.url } }
    }).subscribe(res => {
      if (res.status == true) {
        console.log('CURRENT WEBSECTION', res);
        this.cont = res.result.data[0];
        this.seo.generateTags({
          title:'WWF Educación Ambiental, '+this.cont.tagtitle,
          description: this.cont.tagdescription,
          image: this.api.route + this.cont.tagimage,
          slug: window.location.href,
        });
      }
      else {
        console.log('ERROR ON LOAD', this.url);
      }
    })
  }

  printContent() {
    this.child.expandAccordions();

    setTimeout(()=>{
      window.print();
    },500)
  }

}
